import React from 'react';
import { BatteryWarning } from 'lucide-react';
import { useLanguage } from '../../i18n';

/**
 * Shown whenever the tank reports `locked`.
 *
 * This is the Hub's half of lockdown — an explanation of WHY things stopped
 * working, sitting next to the numbers that prove it. Actually disabling the
 * chat composer and uploads is a separate, later slice (it belongs to
 * MainOfficeView); the shared state it will read is `useEnergyTank().locked`.
 */
const EnergyLockdownBanner = ({ tank }) => {
    const { t } = useLanguage();
    return (
        <div
            data-testid="energy-lockdown-banner"
            role="alert"
            data-enforcement={tank?.enforcement || ''}
            className="flex items-start gap-2.5 px-4 py-3 rounded-card border border-pai-red/[0.35] bg-pai-red/[0.05] min-w-0 max-w-full"
        >
            <BatteryWarning size={16} className="text-pai-red flex-shrink-0 mt-0.5" />
            <div className="min-w-0">
                <p className="text-[15px] font-bold text-pai-red break-words">
                    {t('energyEmpty', "PAI's energy is empty.")}
                </p>
                <p className="text-[13px] text-pai-secondary break-words mt-1">
                    {t(
                        'energyLockdownBody',
                        'New requests are paused until your next cycle or a top-up. Your data is untouched.',
                    )}
                </p>
            </div>
        </div>
    );
};

export default EnergyLockdownBanner;
